import { activeHealthPlanAndClinicCardForMemberReport } from "./activeHealthPlanAndClinicCardForMemberReport";
import { activePaycheckReport } from "./activePaycheckReport";
import { activePlanForEmployeeReport } from "./activePlanForEmployeeReport";
import { benefitChangesReport } from "./benefitChangesReport";
import { censusReport } from "./censusReport";
import { coreActiveEnrollmentsForYOEReport } from "./coreActiveEnrollmentsForYOEReport";
import { VEBPreviouslyActiveCurrentlyWaivedForYOEReport } from "./VEBPreviouslyActiveCurrentlyWaivedForYOERepor";
import { dependentReport } from "./dependentReport";
import { employeeInfoChangesReport } from "./employeeInfoChangesReport";
import { employeeTermination } from "./employeeTerminationReport";
import { getReportLogs } from "./get.reports.reportLogs";
import { locationEmployeeReport } from "./locationEmployeeReport";
import { personalChangeReport } from "./personalChangeReport";
import { planDeductionReport } from "./planDeductionReport";
import { remittanceReport } from "./remittanceReport";
import { totalDeductionReport } from "./totalDeductionReport";
import { VEBActiveEnrollmentsForYOEReport } from "./VEBActiveEnrollmentsForYOEReport";
import { VEBBillingReport } from "./VEBBillingReport";
import { VEBDeductionReport } from "./VEBDeductionReport";
import { VEBWaivedBenefitsReport } from "./VEBWaivedBenefitsReport";
import { wltComparisonReport, wltInfoComparisonReport } from "./wltComparisonReport";
import { corePreviouslyActiveCurrentlyWaivedForYOEReport } from "./corePreviouslyActiveCurrentlyWaivedForYOEReport";
import { corePremiumChangeReport, vebPremiumChangeReport } from "./premiumChangeReport";
import { coreActionTakenOrNotTakenReport } from "./coreActionTakenOrNotTakenReport";
import { VEBActionTakenOrNotTakenReport } from "./VEBActionTakenOrNotTakenReport";
import { VEBEmploymentTerminatedReport } from "./VEBEmploymentTerminatedReport";
import { getReports } from "./get.reports";
import { submitApi } from "./submitApi";

export const reports = {
	submitApi,
	censusReport,
	dependentReport,
	locationEmployeeReport,
	totalDeductionReport,
	planDeductionReport,
	VEBDeductionReport,
	VEBEmploymentTerminatedReport,
	benefitChangesReport,
	personalChangeReport,
	employeeTermination,
	employeeInfoChangesReport,
	wltComparisonReport,
	getReportLogs,
	getReports,
	VEBWaivedBenefitsReport,
	activePlanForEmployeeReport,
	remittanceReport,
	activePaycheckReport,
	activeHealthPlanAndClinicCardForMemberReport,
	VEBBillingReport,
	coreActiveEnrollmentsForYOEReport,
	VEBActiveEnrollmentsForYOEReport,
	corePreviouslyActiveCurrentlyWaivedForYOEReport,
	VEBPreviouslyActiveCurrentlyWaivedForYOEReport,
	corePremiumChangeReport,
	vebPremiumChangeReport,
	coreActionTakenOrNotTakenReport,
	VEBActionTakenOrNotTakenReport,
	wltInfoComparisonReport
};
